import React from 'react';

/** Inline, centered loading indicator for list/detail bodies. */
export const InlineLoader = ({ message = 'Loading…', isDarkMode = false }) => (
  <div className="flex flex-col items-center justify-center py-12">
    <div className="animate-spin rounded-full h-8 w-8 border-4 border-blue-600 border-t-transparent" />
    <p className={`mt-3 text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>{message}</p>
  </div>
);

/** Consistent empty-state block with optional icon and action. */
export const EmptyState = ({ icon: Icon, title, message, action, isDarkMode = false }) => (
  <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
    {Icon && <Icon className={`h-12 w-12 mb-3 ${isDarkMode ? 'text-gray-600' : 'text-gray-300'}`} />}
    {title && (
      <h3 className={`text-sm font-medium ${isDarkMode ? 'text-gray-200' : 'text-gray-900'}`}>{title}</h3>
    )}
    {message && (
      <p className={`mt-1 text-sm max-w-md ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>{message}</p>
    )}
    {action && <div className="mt-4">{action}</div>}
  </div>
);
